module.exports = __webpack_public_path__ + "img/ปลาฉนาก.294e6414.jpeg";